
import { ChangeDetectorRef, Directive, Output } from '@angular/core';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { EventEmitter } from 'events';
import { CustomSortService } from '../services/custom-sort.service';
import { LocalStorageSvc } from '../services/localStorage.service';
import { PreviewImplementation } from './PreviewImplementation';

@Directive()
export class ListViewImplementation {
  public router: any;
  public universalService: any;
  contextMenuService: any;
  public rowData:any=[];
  gridApi: any;
  listService: any;
  public indexsArray:any=[];
  loggerService: any;
  changeDetectorRef: ChangeDetectorRef;
  public static singleInstance: any = null;
  public newlyAddedRowData:any = [];
  @Output() singleFileSelected = new EventEmitter();
  public previewImplementation: any;
  localStorageSvc:LocalStorageSvc;
  customMetadata: any;
  customSort: CustomSortService
  public months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  count: any = 5;
  containerHeightCalc:any;
  db: IndexedDBModule;

  constructor(globalService) {
    this.setHandler(globalService);
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    if(this.universalService.listView){
      this.uploadDone();
    }
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.listService = globalService.getListServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.previewImplementation = PreviewImplementation.getInstance(globalService);
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.db = IndexedDBModule.getInstance(globalService);
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
  }

  public static getInstance(globalService): ListViewImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new ListViewImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  setHeightForListView() {
    var self = this;
    self.setHeightForContainer();
    $(window).resize(function () {
      self.setHeightForContainer();
    });
  }

  setHeightForContainer(){
    var self = this;
    var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
    collapsedHeight = collapsedHeight?collapsedHeight:0
   if ((!self.universalService.isMobileDevice && self.universalService.openFolderContent)||
   (!self.universalService.isMobileDevice && (this.router.url.includes('/filter/recents')))) { 
      setTimeout(() => {
        if(this.router.url.includes('/filter/recents')){
          var height = 0;
          if(self.universalService.selectedTab == 'My Files'){
            height = 0;// $('.heading-wrap').innerHeight()
          }
          self.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],79);
        }else{
          self.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],60);
        }
      }, 1000); 
    }else{
      setTimeout(() => {
        if(self.universalService.virtualGridEnabled)return;
        self.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container', '.pseudo-audiominiplayer'],(67 + collapsedHeight));
      }, 1000);
    }
  }


  // set Recent files in list view starts
  setRecentFilesListview(recentFiles) {
    var self = this;
    this.rowData = [];
    recentFiles.map(function (object) {
        var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
        var fileName =object.objectName.split('.').slice(0, -1).join('.');
        self.rowData.push({
          "name": fileName,
          "extension" : fileExtension,
          "type": object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1),
          "size": object["objectSize"],
          "accessed": object["accessedDate"],
          "ImagePath": object["imageTranscodeUrl"],
          "FullObject": object,
          "objectId": object["objectKey"]
        })
    })
        this.listService.listOptions.api.setRowData(this.rowData);
        this.listService.listOptions.api.sizeColumnsToFit()
        self.listService.setHeaderHeight(60);
        this.universalService.showLoader = false;
        this.universalService.disableModalBackdrop();
  }

  // set Recent files in list view ends




  // fetching and appending audios data to AllFiles List View Starts
  setRowDataForList(allFilesList) {
    var self = this;
    this.rowData = [];
    allFilesList.map(function (object) {
        var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
        var fileName =object.objectName.split('.').slice(0, -1).join('.');
        self.rowData.push({
          "name": fileName,
          "extension" : fileExtension,
          "type": object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1),
          "size": object["objectSize"],
          "created": object["gridDate"],
          "ImagePath": object["imageTranscodeUrl"],
          "FullObject": object,
          "objectId": object["objectKey"],
          "drag": self.universalService.allowMoveDrag,
          "uploaded": object["uploadedDateCol"],
          "lastAccessCol": object["lastAccessCol"],
        })
    })
      // self.listService.listOptions.getRowClass = function(params) {
      //   // if(params.data["FullObject"]["objectType"]=="FR")
      //       return 'objectId'+params.data.objectId;
      // }
        this.listService.listOptions.api.setRowData(this.rowData);
        this.listService.listOptions.api.sizeColumnsToFit()
        self.listService.setHeaderHeight(60);
        this.universalService.showLoader = false;
        this.universalService.disableModalBackdrop();
        if(this.universalService.currentTab != 'Trash') {
          this.sortListViewData();
        }
    // let rowNode = this.listService.listOptions.api.getDisplayedRowAtIndex(0);
    // rowNode.setSelected(true);
    // })
  }


  appendRowDataForList(gridData) {
    var self = this;
    this.rowData = []
    gridData.map(function (object) {
      var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
      var fileName =object.objectName.split('.').slice(0, -1).join('.');
      self.rowData.push({
        "name": fileName,
        "extension" : fileExtension,
        "type": object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1),
        "size": object["objectSize"],
        "created": object["gridDate"],
        "ImagePath": object["imageTranscodeUrl"],
        "FullObject": object,
        "objectId":object["objectKey"],
        "drag":self.universalService.allowMoveDrag,
        "uploaded": object["displayName"] == "Folder"?object["gridDate"]:object["uploadedDateCol"],
        "lastAccessCol": object["lastAccessCol"],
      })
    })
  //   self.listService.listOptions.getRowClass = function(params) {
  //     // if(params.data["FullObject"]["objectType"]=="FR")
  //     return 'objectId'+params.data.objectId;
  // }
    this.listService.listOptions.api.applyTransaction({ add: this.rowData })
    this.listService.listOptions.api.sizeColumnsToFit()
    this.universalService.showLoader = false;
    if(this.listService.disableSelectionModeInListView){
      this.listService.disableSelectionModeInListView = false;
      return;
    }
    if(this.listService.headerCheckBoxChecked){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }else if(!this.listService.headerCheckBoxChecked && this.universalService.isViewFileClicked == true) {
      this.universalService.isViewFileClicked = false;        
      document.getElementsByClassName('ag-row-selected')[1].scrollIntoView(); // scroll to selected
    }
  }

  // fetching and appending audios data to allFiles List View ends




  

  // fetching and appending audios data to audios List View Starts
  fetchAudiosView(audioList) {
    this.listService.audiosRowDataSet = false;
    this.rowData = []
    var self = this;
    var imageUrl = ""
      audioList.map(function (index) {
        var fileExtension =  "."+index.objectName.substring(index.objectName.lastIndexOf('.') + 1);
        var fileName =index.objectName.split('.').slice(0, -1).join('.');
        self.rowData.push({
          "ImagePath": index["imageTranscodeUrl"],
          "name": fileName,
          "extension" : fileExtension,
          "type": index["displayName"].substring(0,1).toUpperCase()+index["displayName"].substring(1),
          "duration": index["ObjectDuration"],
          "created": index["gridDate"],
          "modified":index["modifiedDate"],
          "FullObject": index,
          "objectId":index["objectKey"],
          "options": self.listService.options,
          "uploaded":index["uploadedDateCol"]
        })
      })
      // this.loggerService.log("row data set for audio",this.rowData,this.audioOptions);
      this.listService.rowData = this.rowData; // setting the fetched audios into another array, to show on preview
      self.listService.listOptions.api.setRowData(this.rowData);
      self.listService.listOptions.api.sizeColumnsToFit()
      self.listService.setHeaderHeight(60);
      this.listService.audiosRowDataSet = true;
      this.universalService.showLoader = false;
      this.universalService.disableModalBackdrop();

      this.sortListViewData();
  }

  appendRowDataForAudios(audioList) {
    this.listService.audiosRowDataSet = false;
    this.rowData = []
    var self = this;
    var imageUrl = ""
      audioList.map(function (index) {
        var fileExtension =  "."+index.objectName.substring(index.objectName.lastIndexOf('.') + 1);
        var fileName =index.objectName.split('.').slice(0, -1).join('.');
        self.rowData.push({
          "ImagePath": index["imageTranscodeUrl"],
          "name": fileName,
          "extension" : fileExtension,
          "type": index["displayName"].substring(0,1).toUpperCase()+index["displayName"].substring(1),
          "duration": index["ObjectDuration"],
          "created": index["gridDate"],
          "modified":index["modifiedDate"],
          "FullObject": index,
          "objectId":index["objectKey"],
          "options": self.listService.options,
          "uploaded":index["uploadedDateCol"]
        })
      })
      if(this.universalService.showPreview){ // if audio preview is open, the we need to append data to the list
        this.listService.audioPreviewOptions.api.applyTransaction({ add: this.rowData });
        this.listService.audioPreviewOptions.api.sizeColumnsToFit();
      }else{
        this.listService.listOptions.api.applyTransaction({ add: this.rowData });
        this.listService.listOptions.api.sizeColumnsToFit();
      }
      this.listService.rowData = this.listService.rowData.concat(this.rowData);
      if(this.listService.disableSelectionModeInListView){
        this.listService.disableSelectionModeInListView = false;
        return;
      }
    if(this.listService.headerCheckBoxChecked){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }
    this.universalService.showLoader = false;
    this.listService.audiosRowDataSet = true; 
  }

  // fetching and appending audios data to audios List View Ends




  // fetching and appending audios data to Docs List View Starts

  fetchDocsView(docList) { 
    this.listService.docsRowDataSet  = false;
    var self = this;
    this.rowData = []
      docList.map(function (obj) {
        var fileExtension=""
        var fileName =""
        if(obj.objectName.indexOf('.')>0){
          fileExtension =  "."+obj.objectName.substring(obj.objectName.lastIndexOf('.') + 1);
          fileName =obj.objectName.split('.').slice(0, -1).join('.');
        }else{
          fileName =obj.objectName;//.split('.').slice(0, -1).join('.');
          fileExtension=""
        }
        if(obj["imageTranscodeUrl"]){
          self.rowData.push({
            "ImagePath": obj["imageTranscodeUrl"],
            "name": fileName,
            "extension" : fileExtension,
            "type": obj["displayName"].substring(0,1).toUpperCase()+obj["displayName"].substring(1),
            "size": obj["objectSize"],
            "created": obj["gridDate"],
            "modified":obj["modifiedDate"],
            "FullObject": obj,
            "objectId":obj["objectKey"],
            "uploaded":obj["uploadedDateCol"]
          })
        }else{
          self.rowData.push({
            "ImagePath": "document",
            "name": fileName,
            "extension" : fileExtension,
            "type": obj["displayName"].substring(0,1).toUpperCase()+obj["displayName"].substring(1),
            "size": obj["objectSize"],
            "created": obj["gridDate"],
            "modified":obj["modifiedDate"],
            "FullObject": obj,
            "objectId":obj["objectKey"],
            "uploaded":obj["uploadedDateCol"]
          })
        }
      })
      // this.loggerService.log("docs data set in rowdata",this.rowData)
      this.listService.listOptions.api.setRowData(this.rowData);
      this.listService.listOptions.api.sizeColumnsToFit()
      self.listService.setHeaderHeight(60);
      this.listService.docsRowDataSet = true;
      this.universalService.showLoader = false;
      this.universalService.disableModalBackdrop();

      this.sortListViewData()
  }


  appendRowDataForDocs(docList) {
    this.listService.docsRowDataSet = false;
    var self = this;
    this.rowData = []
      docList.map(function (obj) {
        var fileExtension=""
        var fileName =""
        if(obj.objectName.indexOf('.')>0){
          fileExtension =  "."+obj.objectName.substring(obj.objectName.lastIndexOf('.') + 1);
          fileName =obj.objectName.split('.').slice(0, -1).join('.');
        }else{
          fileName =obj.objectName;//.split('.').slice(0, -1).join('.');
          fileExtension=""
        }
        if(obj["imageTranscodeUrl"]){
          self.rowData.push({
            "ImagePath": obj["imageTranscodeUrl"],
            "name": fileName,
            "extension" : fileExtension,
            "type": obj["displayName"].substring(0,1).toUpperCase()+obj["displayName"].substring(1),
            "size": obj["objectSize"],
            "created": obj["gridDate"],
            "modified":obj["modifiedDate"],
            "FullObject": obj,
            "objectId":obj["objectKey"],
            "uploaded":obj["uploadedDateCol"]
          })
        }else{
          self.rowData.push({
            "ImagePath": "document",
            "name": fileName,
            "extension" : fileExtension,
            "type": obj["displayName"].substring(0,1).toUpperCase()+obj["displayName"].substring(1),
            "size": obj["objectSize"],
            "created": obj["gridDate"],
            "modified":obj["modifiedDate"],
            "FullObject": obj,
            "objectId":obj["objectKey"],
            "uploaded":obj["uploadedDateCol"]
          })
        }
        
      })
      this.listService.listOptions.api.applyTransaction({ add: this.rowData });
      this.listService.listOptions.api.sizeColumnsToFit();
    if(this.listService.disableSelectionModeInListView){
      this.listService.disableSelectionModeInListView = false
      return;
    }
    if(this.listService.headerCheckBoxChecked){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }
    this.universalService.showLoader = false;
    this.listService.docsRowDataSet = true;
  }


  // fetching and appending audios data to docs List View Ends

  // fetch teams folders trash view starts
  fetchTeamFolderTrashedObjects(trashedFiles){
    var self = this;
    this.rowData = []
    trashedFiles.map(function (obj) {
        var fileExtension=""
        var fileName =""
        if(obj.objectName.indexOf('.')>0){
          fileExtension =  "."+obj.objectName.substring(obj.objectName.lastIndexOf('.') + 1);
          fileName =obj.objectName.split('.').slice(0, -1).join('.');
        }else{
          fileName =obj.objectName;//.split('.').slice(0, -1).join('.');
          fileExtension=""
        }
        self.rowData.push({
          "ImagePath": obj["imageTranscodeUrl"],
          "name": fileName,
          "extension" : fileExtension,
          "type": obj["displayName"].substring(0,1).toUpperCase()+obj["displayName"].substring(1),
          "size": obj["objectSize"],
          "deleted": obj["deletedDate"],
          "deletedby": (obj["objectDeletedBy"]["firstName"] ? obj["objectDeletedBy"]["firstName"] : "") + " " + (obj["objectDeletedBy"]["lastName"] ? obj["objectDeletedBy"]["lastName"] : ""),
          "FullObject": obj,
          "objectId":obj["objectKey"]
        })
      })
      this.listService.listOptions.api.setRowData(this.rowData);
      this.listService.listOptions.api.sizeColumnsToFit()
      self.listService.setHeaderHeight(60);
      this.universalService.showLoader = false;
      this.universalService.disableModalBackdrop();
  }
  // fetch teams folder trash view ends


  appendTeamFolderTrashedObjects(trashedFiles){
    var self = this;
    this.rowData = []
    trashedFiles.map(function (obj) {
        var fileExtension=""
        var fileName =""
        if(obj.objectName.indexOf('.')>0){
          fileExtension =  "."+obj.objectName.substring(obj.objectName.lastIndexOf('.') + 1);
          fileName =obj.objectName.split('.').slice(0, -1).join('.');
        }else{
          fileName =obj.objectName;//.split('.').slice(0, -1).join('.');
          fileExtension=""
        }
        self.rowData.push({
          "ImagePath": obj["imageTranscodeUrl"],
          "name": fileName,
          "extension" : fileExtension,
          "type": obj["displayName"].substring(0,1).toUpperCase()+obj["displayName"].substring(1),
          "size": obj["objectSize"],
          "deleted": obj["deletedDate"],
          "deletedby": (obj["objectDeletedBy"]["firstName"] ? obj["objectDeletedBy"]["firstName"] : "") + " " + (obj["objectDeletedBy"]["lastName"] ? obj["objectDeletedBy"]["lastName"] : ""),
          "FullObject": obj,
          "objectId":obj["objectKey"]
        })
      })
      this.listService.listOptions.api.applyTransaction({ add: this.rowData });
      this.listService.listOptions.api.sizeColumnsToFit();
      if(this.listService.disableSelectionModeInListView){
        this.listService.disableSelectionModeInListView = false
        return;
      }
      if(this.listService.headerCheckBoxChecked){
        this.listService.listOptions.api.selectAll();
        this.listService.deselectedNodesArray.map(function(rowNode){
          rowNode.setSelected(false);
        })
      }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
        this.listService.listOptions.api.selectAll();
        this.listService.deselectedNodesArray.map(function(rowNode){
          rowNode.setSelected(false);
        })
      }
      this.universalService.showLoader = false;
  }


  // fetch favorites list view starts
      fetchFavoritesListView(favFiles){
        var self = this;
        this.rowData = [];
        favFiles.map(function (object) {
            var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
            var fileName =object.objectName.split('.').slice(0, -1).join('.');
            self.rowData.push({
              "name": fileName,
              "extension" : fileExtension,
              "type": object["displayName"]?object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1):object["mimeType"].substring(0,1).toUpperCase()+object["mimeType"].substring(1),
              "size": object["objectSize"],
              "starred": object["favDate"],
              "ImagePath": object["imageTranscodeUrl"],
              "FullObject": object,
              "objectId": object["objectKey"]
            })
        })
        // setTimeout(() => {
            this.listService.listOptions.api.setRowData(this.rowData);
            this.listService.listOptions.api.sizeColumnsToFit()
            self.listService.setHeaderHeight(60);
        // }, 1000);
        this.universalService.showLoader = false;
        this.universalService.disableModalBackdrop();
    }

    appendToFavoritesListView(favFiles){
      var self = this;
      this.rowData = [];
      favFiles.map(function (object) {
          var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
          var fileName =object.objectName.split('.').slice(0, -1).join('.');
          self.rowData.push({
            "name": fileName,
            "extension" : fileExtension,
            "type": object["displayName"]?object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1):object["mimeType"].substring(0,1).toUpperCase()+object["mimeType"].substring(1),
            "size": object["objectSize"],
            "starred": object["favDate"],
            "ImagePath": object["imageTranscodeUrl"],
            "FullObject": object,
            "objectId": object["objectKey"]
          })
      })
      this.listService.listOptions.api.applyTransaction({ add: this.rowData });
      this.listService.listOptions.api.sizeColumnsToFit()
      if(this.listService.headerCheckBoxChecked){
        this.listService.listOptions.api.selectAll();
        this.listService.deselectedNodesArray.map(function(rowNode){
          rowNode.setSelected(false);
        })
      }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
        this.listService.listOptions.api.selectAll();
        this.listService.deselectedNodesArray.map(function(rowNode){
          rowNode.setSelected(false);
        })
      }
      this.universalService.showLoader = false;
  }

  // fetch favorites list view

  // fetch sent files list view starts
  fetchSentFilesListView(fileList){
    var self = this;
    this.rowData = [];
    fileList.map(function (object) {
        var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
        var fileName =object.objectName.split('.').slice(0, -1).join('.');
        self.rowData.push({
          "name": fileName,
          "extension" : fileExtension,
          "owner": (object["objectShareBy"]["firstName"])?(object["objectShareBy"]["firstName"] + " " + ((object["objectShareBy"]["lastName"]) ? object["objectShareBy"]["lastName"] : "")) : "Me",
          "size": object["objectSize"],
          "type": object["format"].substring(0,1).toUpperCase()+object["format"].substring(1),
          "modified": self.universalService.openFolderContent?object["modifiedDate"]:object["shareModified"],
          "shareDate":object["sharedDate"],
          // "comment": object["comment"],
          "ImagePath": object["imageTranscodeUrl"],
          "FullObject": object,
          "objectId": object["objectKey"],
          "showFavIcon":false
        })
    })
    // self.listService.listOptions.getRowClass = function(params) {
    //   // if(params.data["FullObject"]["objectType"]=="FR")
    //   return 'objectId'+params.data.objectId;
    // }
    // setTimeout(() => {
        
        this.listService.listOptions.api.setRowData(this.rowData);
        this.listService.listOptions.api.sizeColumnsToFit()
        self.listService.setHeaderHeight(60);
    // }, 1000);
    
    this.universalService.showLoader = false;
    this.universalService.disableModalBackdrop();
  }
  // fetch sent files list view ends

  
  // append sent files list view starts
  appendRowDataForSentFiles(fileList) {
    var self = this;
    this.rowData = []
    fileList.map(function (object) {
      var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
      var fileName =object.objectName.split('.').slice(0, -1).join('.');
      self.rowData.push({
        "name": fileName,
        "extension" : fileExtension,
        "owner": "Me",
        "size": object["objectSize"],
        "type": object["format"].substring(0,1).toUpperCase()+object["format"].substring(1),
        "modified": self.universalService.openFolderContent?object["modifiedDate"]:object["shareModified"],
        "shareDate":object["sharedDate"],
        "ImagePath": object["imageTranscodeUrl"],
        "FullObject": object,
        "objectId": object["objectKey"],
        "showFavIcon":false
      })
    })
    // self.listService.listOptions.getRowClass = function(params) {
    //   // if(params.data["FullObject"]["objectType"]=="FR")
    //   return 'objectId'+params.data.objectId;
    // }
    this.listService.listOptions.api.applyTransaction({ add: this.rowData });
    this.listService.listOptions.api.sizeColumnsToFit()
    if(this.listService.headerCheckBoxChecked){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }
    this.universalService.showLoader = false;
  }
  // append sent files list view ends


  // fetch received files list view starts
  fetchReceivedFilesListView(fileList){
    var self = this;
    this.rowData = [];
    fileList.map(function (object) {
        var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
        var fileName =object.objectName.split('.').slice(0, -1).join('.');
        self.rowData.push({
          "name": fileName,
          "extension" : fileExtension,
          "type": object["format"].substring(0,1).toUpperCase()+object["format"].substring(1),
          "size": object["objectSize"],
          "modified": (self.universalService.openFolderContent || self.universalService.activeRepo == 'share')?object["modifiedDate"]:object["shareModified"],
          "shareDate":object["sharedDate"],
          "ImagePath": object["imageTranscodeUrl"],
          "sharedBy":(object["objectShareBy"]["firstName"])?(object["objectShareBy"]["firstName"] + " " + ((object["objectShareBy"]["lastName"]) ? object["objectShareBy"]["lastName"] : "")) : "-",
          "FullObject": object,
          "objectId": object["objectKey"],
          "showFavIcon":false
        })
    })
    // self.listService.listOptions.getRowClass = function(params) {
    //   // if(params.data["FullObject"]["objectType"]=="FR")
    //   return 'objectId'+params.data.objectId;
    // }
    // setTimeout(() => {
        this.listService.listOptions.api.setRowData(this.rowData);
        this.listService.listOptions.api.sizeColumnsToFit()
        self.listService.setHeaderHeight(60);
    // }, 1000);
    this.universalService.showLoader = false;
    this.universalService.disableModalBackdrop();
  }
  // fetch received files list view ends

  // append received files list view starts
  appendRowDataForReceivedFiles(fileList) {
    var self = this;
    this.rowData = []
    fileList.map(function (object) {
      var fileExtension =  "."+object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
      var fileName =object.objectName.split('.').slice(0, -1).join('.');
      self.rowData.push({
        "name": fileName,
        "extension" : fileExtension,
        "type": object["format"].substring(0,1).toUpperCase()+object["format"].substring(1),
        "size": object["objectSize"],
        "modified": self.universalService.openFolderContent?object["modifiedDate"]:object["shareModified"],
        "shareDate":object["sharedDate"],
        "ImagePath": object["imageTranscodeUrl"],
        "sharedBy":(object["objectShareBy"]["firstName"])?(object["objectShareBy"]["firstName"] + " " + object["objectShareBy"]["lastName"]):"-",
        "FullObject": object,
        "objectId": object["objectKey"],
        "showFavIcon":false
      })
  })
  // self.listService.listOptions.getRowClass = function(params) {
  //   // if(params.data["FullObject"]["objectType"]=="FR")
  //   return 'objectId'+params.data.objectId;
  // }
    this.listService.listOptions.api.applyTransaction({ add: this.rowData });
    this.listService.listOptions.api.sizeColumnsToFit()
    if(this.universalService.activeRepo == 'share'){
      this.universalService.showLoader = false;
      return;
    }
    if(this.listService.headerCheckBoxChecked){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
      this.listService.listOptions.api.selectAll();
      this.listService.deselectedNodesArray.map(function(rowNode){
        rowNode.setSelected(false);
      })
    }
    this.universalService.showLoader = false;
  }
  // append received files list view ends

  // fetch shared link by me list view starts
  fetchSharedLinkByMeListView(fileList) {
    var self = this;
    self.rowData = [];
    fileList.map(function (object) {
        self.rowData.push({
          "name": object["shareName"],
          "type": object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1),
          "shareURL": object["shareURL"],
          "createdDate":object["gridDate"],
          "ImagePath": object["imageTranscodeUrl"],
          "FullObject": object,
          "objectId": object["shareKey"],
          "iconClassName" : 'three-dot',
          "isSortingRequired" : false
        })
    })
 
    self.listService.listOptions.api.setRowData(self.rowData);
    setTimeout(() => {
      self.listService.listOptions.api.sizeColumnsToFit();
    }, 1);
    self.listService.setHeaderHeight(60);
    self.universalService.showLoader = false;
    self.universalService.disableModalBackdrop();
    self.hideSortingArrowForColumn(self.listService.listOptions,fileList)
  }
  // fetch shared link by me list view ends

  fetchTeamFoldersListView(fileList,appendToExistingList=false) {
    var self = this;
    self.rowData = [];
    fileList.map(function (object) {
        self.rowData.push({
          "ImagePath":"",
          "name": object["tfName"],
          "size": object["objectSize"],
          "type": "Folder",
          "members" : object["tfMemberCount"],
          "FullObject": object,
          "objectId": object["objectKey"],
          "tfKey": object["tfKey"],
          "iconClassName" : 'three-dot',
        })
    })
    if(appendToExistingList){
      self.listService.listOptions.api.applyTransaction({ add: self.rowData });
    }
    else{
      self.listService.listOptions.api.setRowData(self.rowData);
    }
    self.listService.listOptions.api.sizeColumnsToFit()
    self.listService.setHeaderHeight(60);
    self.universalService.showLoader = false;
    self.universalService.disableModalBackdrop();
  }
  
  fetchTeamFoldersContentListView(fileList,appendToExistingList=false) {
    var self = this;
    self.rowData = [];
    fileList.map(function (object) {
      var fileExtension = "." + object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
      var fileName = object.objectName.split('.').slice(0, -1).join('.');
        self.rowData.push({
          "name": fileName,
          "extension": fileExtension,
          "size": object["objectSize"],
          "createdByName": object["objectCreatedBy"] ? (object["objectCreatedBy"]["firstName"] ? object["objectCreatedBy"]["firstName"] : "-") + " " + (object["objectCreatedBy"]["lastName"] ? object["objectCreatedBy"]["lastName"] : "-") : (USER_DETAILS["USER_DETAILS"]["firstName"] + " " + USER_DETAILS["USER_DETAILS"]["lastName"]),//On copy show logged in user as creator of object if not available
          "type": object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1),
          "created": object["gridDate"],
          "ImagePath": object["imageTranscodeUrl"],
          "FullObject": object,
          "objectId": object["objectKey"],
          "tfKey": object["tfKey"],
          "iconClassName" : 'three-dot',
        })

        // self.listService.listOptions.getRowClass = function(params) {
        //   return 'objectId'+params.data.objectId;
        // }
    })
    if(appendToExistingList){
      self.listService.listOptions.api.applyTransaction({ add: self.rowData });
      if(this.listService.headerCheckBoxChecked){
        this.listService.listOptions.api.selectAll();
        this.listService.deselectedNodesArray.map(function(rowNode){
          rowNode.setSelected(false);
        })
      }else if(!this.listService.headerCheckBoxChecked && this.listService.deselectedNodesArray.length != 0){
        this.listService.listOptions.api.selectAll();
        this.listService.deselectedNodesArray.map(function(rowNode){
          rowNode.setSelected(false);
        })
      }
    }
    else{
      self.listService.listOptions.api.setRowData(self.rowData);
    }
    self.listService.listOptions.api.sizeColumnsToFit()
    self.listService.setHeaderHeight(60);
    self.universalService.showLoader = false;
    self.universalService.disableModalBackdrop();
  }

  fetchBackupsListView(fileList) {
    var self = this;
    this.rowData = [];
    fileList.map(function (object) {
        object["objectName"] = object["folderName"];
        self.rowData.push({
          "name": object["folderName"],
          "type": "Folder",
          "backupDate":"19th August 2022",
          "ImagePath": object["providerFolderImage"],
          "FullObject": object,
          "objectId": object["emailId"],
          "backupView":true
        })
        self.listService.listOptions.getRowClass = function(params) {
          if (params.node.data.backupView == true) {
              return 'hideRowBorder';
          }
        }
    })
    this.listService.listOptions.api.setRowData(this.rowData);
    this.listService.listOptions.api.sizeColumnsToFit()
    self.listService.setHeaderHeight(60);
    this.universalService.showLoader = false;
    this.universalService.disableModalBackdrop();
  }

  appendRowDataForSharedLinkByMeList(fileList) {
    var self = this;
    this.rowData = []
    fileList.map(function (object) {
      self.rowData.push({
        "name": object["shareName"],
        "type": object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1),
        "shareURL": object["shareURL"],
        "createdDate":object["gridDate"],
        "ImagePath": object["imageTranscodeUrl"],
        "FullObject": object,
        "objectId": object["shareKey"],
        "iconClassName" : 'three-dot',
        "isSortingRequired" : false
      })
  })
    this.listService.listOptions.api.applyTransaction({ add: this.rowData });
    this.listService.listOptions.api.sizeColumnsToFit()
    if(this.universalService.activeRepo == 'share'){
      this.universalService.showLoader = false;
      return;
    }

    this.universalService.showLoader = false;
  }

  fetchiCloudBackupStatusListView(fileList) {
    var self = this;
    self.rowData = [];
    fileList.map(function (object) {
      if(self.universalService.isMobileDevice){
        self.rowData.push({
          "name": object["objectShortName"],
          "size": object["objectSize"],
          "status":object["status"]
        })
      }else{
        self.rowData.push({
          "name": object["sourceObjectName"],
          "size": object["objectSize"],
          "status":object["status"]
        })
      }    
    })
 
    self.listService.listOptions.api.setRowData(self.rowData);
    setTimeout(() => {
      self.listService.listOptions.api.sizeColumnsToFit();
    }, 1);
    self.listService.setHeaderHeight(60);
    self.universalService.showLoader = false;
    self.universalService.disableModalBackdrop();
    self.hideSortingArrowForColumn(self.listService.listOptions,fileList)
  }

  getFolders(suc) {
    this.listService.noFoldersPresent = false;
    var self = this;
    this.rowData = [];
    this.rowData = []
    var folderData = suc["objects"]
    folderData.map(function (folder) {
      if (folder["objectType"] == "FR") {
        self.rowData.push({
          "ImagePath": "Folder",
          "type": "Folder",
          "fileName": folder["objectName"],
          "FullObject": folder,
          "addToJiocloudgFolderItem": "true"
        })
      }
    })
    if (this.rowData.length == 0) {
      this.listService.noFoldersPresent = true;
      this.universalService.showLoader = false;
    } else {
      setTimeout(() => {
        this.listService.addToJCOptions.api.setRowData(this.rowData);
        this.listService.addToJCOptions.api.sizeColumnsToFit()
        this.universalService.showLoader = false;
      }, 10)
    }
  }

  checkIfOnlyFilesArePresendInsideFolder(files){
    var found = files.filter(obj=> {
      const type = obj["objectType"] ? obj["objectType"] : obj["FullObject"]["objectType"];
      return type =="FR";
    })
    return (found.length==0?true:false)
  }
  async getFoldersForMoveCopy(suc){
    this.listService.noFoldersPresent = false;
    var self = this;
    this.rowData = [];
    var folderData = suc;
    await folderData.map(function (folder) {
      // if(self.universalService.selectedFile["objectType"]=='FR' && self.universalService.popUpToBeOpened == 'movePopUp' && self.universalService.selectedFile["FullObject"]["objectKey"] == folder["objectKey"]){
      //   return;
      // }
        self.rowData.push({
          "ImagePath": folder["imageTranscodeUrl"],
          "type": folder["format"].substring(0,1).toUpperCase()+folder["format"].substring(1),
          "fileName": folder["objectName"],
          "FullObject": folder,
        })

        // self.listService.moveCopyOptions.getRowClass = function(params) {
        //   if (params.node.data.FullObject.objectType == 'FE') {
        //       return 'hideMoveCopyFile';
        //   }
        // }
    })
    if (self.rowData.length == 0 || this.checkIfOnlyFilesArePresendInsideFolder(self.rowData)) {
      this.listService.noFoldersPresent = true;
      this.universalService.showLoader = false;
    } else {
      setTimeout(() => {
        this.listService.moveCopyOptions.api.setRowData(this.rowData);
        this.listService.moveCopyOptions.api.sizeColumnsToFit()
        this.universalService.showLoader = false;
        if((this.universalService.popUpToBeOpened == 'movePopUp' || self.universalService.popUpToBeOpened == 'copyPopUp')){
          this.setagGridHeightForMoveCopyMobile();
        } 
      }, 500)
    }
    //this.universalService.showLoader = false;
  }
  setagGridHeightForMoveCopyMobile(){
    if(this.universalService.isMobileDevice){
      this.containerHeightCalc.calculateHeight('.moveCopyModalContent #ag-grid',['.modal-header'],-95)
    } 
  }
  getAlbums(albumList) {
    this.listService.noFoldersPresent = false;
    this.listService.noAlbumsPresent = false;
    var self = this;
    this.rowData = [];
    this.rowData = []
    var albumsData = albumList["boards"]
    if (albumsData) {
      albumsData.map(function (album) {
        if (!album["boardCoverPic"]) {
          album["boardCoverPic"] = ""
        } else {
          let type = self.universalService.checkIfImgTypeParamIsRequired(album["coverPicMimeSubType"]);
          let coverPicUrl = album["boardCoverPic"].includes("?") ? album["boardCoverPic"] + "&" : album["boardCoverPic"] + "?";
          coverPicUrl = coverPicUrl + "size=c&devicetype=web" + type;
          album["boardCoverPic"] = coverPicUrl;
        }
        if (album["boardType"] == "P") {
          self.rowData.push({
            "ImagePath": album["boardCoverPic"],
            "type": "Album",
            "fileName": album["boardName"],
            "FullObject": album
          })
        }
      })
    }
    // this.loggerService.log("row data for Albums ",this.rowData);
    if (this.rowData.length == 0) {
      this.listService.noAlbumsPresent = true;
    }
    this.universalService.showLoader = false;
    return this.rowData
  }




  selectAll(eve) {
    let openModalList = document.querySelectorAll('.modal.fade');
    let openModalListWhichAreNotUsingModalFade = Array.prototype.slice.call(document.querySelectorAll('.modal-popup'));
    let modalsList = Array.prototype.slice.call(openModalList).concat(openModalListWhichAreNotUsingModalFade)
    const isModalOpen = modalsList.some(modal=> {
      let style = window.getComputedStyle(modal)
      return (style.getPropertyValue('display') == 'block' || (document.getElementById('advc-search') == document.activeElement));
    })
    if(isModalOpen){
      return
    }
    if( (this.universalService.activeRepo == 'share' && !window.location.href.includes("?u") ) || this.universalService.isUserOnSharedLinkByMe)
    return;
  
    if (eve.metaKey == true && eve.keyCode == 65 && this.listService.listOptions.api.getDisplayedRowCount()>0) {
      this.listService.listOptions.api.selectAll();
      this.universalService.showTopMenu = true;    
      this.universalService.showTopMenuOptions();  
      this.universalService.selectedNodes = this.listService.listOptions.api.getSelectedRows();
      // this.contextMenuService.decideContextMenuItems();
    }else if (eve.ctrlKey == true && (eve.key == 'a'||eve.key == 'A') && this.listService.listOptions.api.getDisplayedRowCount()>0) {
      this.listService.listOptions.api.selectAll();
      this.universalService.showTopMenu = true;
      this.universalService.showTopMenuOptions();  
      this.universalService.selectedNodes = this.listService.listOptions.api.getSelectedRows();
      // this.contextMenuService.decideContextMenuItems();
    }
  }


  onGridReady(params) {
    this.gridApi = params.api; // To access the grids API
    this.listService.listOptions.api = this.gridApi;
  }

  // scrollToRow(){
  //   setTimeout(()=>{
  //     params.api.ensureIndexVisible(30);
  //   },5000)
  // }


  hideSortingArrowForColumn(listOptions,obj){
    // var columnDefs = this.listService.listOptions.api["columnModel"]["columnDefs"];
    // columnDefs.forEach(function(colDef, index) {
    //   if(colDef["sortable"] != undefined){
    //     if((obj.length && obj.length==1) || obj == 1){
    //       colDef.sortable = false;
    //     }else{
    //       colDef.sortable = true;
    //     }
    //   }
    // });
    // this.listService.listOptions.api.setGridOption('columnDefs', columnDefs);
  }
  

  decideListOptions(tab){
    if(this.universalService.userLoggedIn){
      this.setListOptionsForLoggedInUser(tab);
    }else{
      this.setListOptionsForNotLoggedInUser(tab);
    }

    this.loggerService.log("LIST OPTIONS ARE ====>",this.listService.listOptions);
  }


  setListOptionsForLoggedInUser(tab){
    this.listService.listOptions.suppressRowClickSelection = false;
    this.listService.listOptions.rowHeight = 50;
    this.listService.listOptions.rowSelection = 'multiple';
    this.indexsArray = [];
    switch(tab){
      case 'audio':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.audioDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.audioDefs)
        this.applyColumnStateForRecentUploadSort(tab);
        break;
      case 'docs':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.DocsDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.DocsDefs)
        this.applyColumnStateForRecentUploadSort(tab);
        break;
      case 'recents':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.recentFilesDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.recentFilesDefs)
        break;
      case 'allfiles':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.allFilesDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.allFilesDefs);
        this.applyColumnStateForRecentUploadSort(tab);
        break;
      case 'favorites':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.FavoritesDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.FavoritesDefs)
        break;
      case 'trash':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.trashFilesDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.trashFilesDefs)
        break;
      case "sharedbyme" : 
        this.listService.setShareListViewSortOrder(this.listService.listViewSortOrder);
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.SharedByMeDefs)){
          this.listService.listOptions.api.setGridOption('columnDefs', this.listService.SharedByMeDefs);
        }
        this.applyColumnStateForSharedFiles();
        this.listService.listOptions.api.sizeColumnsToFit()
        break;
      case "sharedwithme" : 
        this.listService.setShareListViewSortOrder(this.listService.listViewSortOrder);
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.SharedWithMeDefs)){
          this.listService.listOptions.api.setGridOption('columnDefs', this.listService.SharedWithMeDefs);
        }
          this.applyColumnStateForSharedFiles();
        this.listService.listOptions.api.sizeColumnsToFit()
        break;

      case "sharedlinkbyme" :
        this.listService.listOptions.suppressRowClickSelection = true;
        this.listService.setSharedLinkByMeSortOrder(this.listService.sharedLinkByMeSortOrder);
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.sharedLinkByMeDef)){
          this.listService.listOptions.api.setGridOption('columnDefs', this.listService.sharedLinkByMeDef);
        }
        // this.applyColumnStateForSharedFiles();
        this.listService.listOptions.api.sizeColumnsToFit();
        break;
      // case 'sharedlinkbymecd': // sharedlinkbyme created date sorting
      //   if(this.listService.sharedLinkByMeSortOrder.indexOf('%2DcreatedDate')>=0){
      //     this.listService.sharedLinkByMeCreatedDateDefs.find(t=>t.headerName ==='Date Created').sort = 'desc';
      //   }
      //   else {
      //     this.listService.sharedLinkByMeCreatedDateDefs.find(t=>t.headerName ==='Date Created').sort = 'asc';
      //   }
      //   this.listService.setSharedLinkByMeSortOrder(this.listService.sharedLinkByMeSortOrder);
        
      // break;
      // case 'sharedlinkbymesname':
      //   if(this.listService.sharedLinkByMeSortOrder.indexOf('%2DshareName')>=0){
      //     this.listService.sharedLinkByMeDef.find(t=>t.headerName ==='Name').sort = 'desc';
      //   }
      //   else {
      //     this.listService.sharedLinkByMeDef.find(t=>t.headerName ==='Name').sort = 'asc';
      //   }
      //   this.listService.setSharedLinkByMeSortOrder(this.listService.sharedLinkByMeSortOrder);
      //   this.listService.listOptions.suppressRowClickSelection = true;
      //   if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.sharedLinkByMeDef))
      //   this.listService.listOptions.api.setGridOption('columnDefs', this.listService.sharedLinkByMeDef);
      //   this.listService.listOptions.api.sizeColumnsToFit();
      // break;
      case 'teamfolders':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.teamFoldersRootDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.teamFoldersRootDefs);
        this.listService.listOptions.api.sizeColumnsToFit();
        this.listService.listOptions.suppressRowClickSelection = true;
        this.listService.listOptions.rowSelection = 'single';
      break;
      case 'teamfoldercontent':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.teamFolderContentDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.teamFolderContentDefs);
        this.listService.listOptions.api.sizeColumnsToFit();
      break;
      case 'teamfolderstrash':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.teamFoldersTrashDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.teamFoldersTrashDefs)
        break;
      case 'icloudBackup':
        this.listService.listOptions.suppressRowClickSelection = true;
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.icloudBcakupStatus)){
          if(!this.universalService.isMobileDevice){
            if(!this.universalService.hideSizeColumn){
              this.listService.listOptions.api.setGridOption('columnDefs', this.listService.icloudBcakupStatus);
            }else{
              this.listService.listOptions.api.setGridOption('columnDefs', this.listService.hideSizeColumnForGPhotos);
            }
          }else{
            if(this.universalService.hideSizeColumn){
              this.listService.listOptions.api.setGridOption('columnDefs', this.listService.hideSizeColumnForGPhotosMob);
            }else{
              this.listService.listOptions.api.setGridOption('columnDefs', this.listService.icloudBcakupStatusMob);
            }
          }
        }
        this.listService.listOptions.api.sizeColumnsToFit();
      default:
        this.loggerService.log("no value found for the tab");
    }
  }
  setListOptionsForNotLoggedInUser(tab){
    switch(tab){
      case 'audio':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.preLoginAudioDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.preLoginAudioDefs)
        this.applyColumnStateForRecentUploadSort(tab);
        break;
      case 'docs':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.preLoginDocsDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.preLoginDocsDefs)
        this.applyColumnStateForRecentUploadSort(tab);
        break;
      case 'allfiles':
        if(JSON.stringify(this.listService.listOptions.api["columnModel"]["columnDefs"]) != JSON.stringify(this.listService.preLoginAllFilesDefs))
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.preLoginAllFilesDefs)
        this.applyColumnStateForRecentUploadSort(tab);
        break;
      default:
        this.loggerService.log("no value found for the tab");
    }
  }

  applyColumnStateForSharedLinkByMe(){
    if(this.listService.sharedLinkByMeSortOrder.includes("%2DshareName")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'shareName', sort: 'desc' }],
        defaultState: { sort: null },
      });
    }else if(this.listService.sharedLinkByMeSortOrder.includes("%2BshareName")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'shareName', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }else if(this.listService.sharedLinkByMeSortOrder.includes("%2DcreatedDate")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'createdDate', sort: 'desc' }],
        defaultState: { sort: null },
      });
    }else if(this.listService.sharedLinkByMeSortOrder.includes("%2BcreatedDate")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'createdDate', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }
  }

  // showShareDateColumns(){ 
  //   var sharedColumn = this.listService.listOptions.api["columnModel"]["columnDefs"].find(col=>col["field"] == "shareDate");
  //   var indexOfSharedColum = this.listService.listOptions.api["columnModel"]["columnDefs"].indexOf(sharedColumn);
  //   if(indexOfSharedColum >= 0 && this.listService.listOptions.api["columnModel"]["columnDefs"][indexOfSharedColum].hide){
  //       this.listService.listOptions.api["columnModel"]["columnDefs"][indexOfSharedColum].hide = false;
  //   }
  //   this.listService.listOptions.api.applyColumnState({
  //     state: [{ colId: 'modified', sort: 'desc' }],
  //     defaultState: { sort: null },
  //   });
  //   this.listService.listOptions.api.setGridOption('columnDefs', this.listService.listOptions.api["columnModel"]["columnDefs"])
    
  // }
  applyColumnStateForSharedFiles(){
    if(this.listService.listViewSortOrder.includes("%2DobjectName")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'name', sort: 'desc' }],
        defaultState: { sort: null },
      });
      this.hideOrShowSharedColumn(true);
    }else if(this.listService.listViewSortOrder.includes("%2BobjectName")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'name', sort: 'asc' }],
        defaultState: { sort: null },
      });
      this.hideOrShowSharedColumn(true);
    }else if(this.listService.listViewSortOrder.includes("%2Dscd")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'shareDate', sort: 'desc' }],
        defaultState: { sort: null },
      });
      this.hideOrShowSharedColumn(false);
    }else if(this.listService.listViewSortOrder.includes("%2Dsmd") || this.listService.listViewSortOrder.includes("%2Dlmd")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'modified', sort: 'desc' }],
        defaultState: { sort: null },
      });
      this.hideOrShowSharedColumn(true);
    }else if(this.listService.listViewSortOrder.includes("%2Bscd")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'shareDate', sort: 'asc' }],
        defaultState: { sort: null },
      });
      this.hideOrShowSharedColumn(false);
    }else if(this.listService.listViewSortOrder.includes("%2Bsmd") || this.listService.listViewSortOrder.includes("%2Blmd")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'modified', sort: 'asc' }],
        defaultState: { sort: null },
      });
      this.hideOrShowSharedColumn(true);
    }
  }
  
  applyColumnStateForRecentUploadSort(tab) {
    if(tab == "docs" && this.universalService.activeRepo == ActiveRepo.SHARE){
        this.listService.listOptions.api.setColumnVisible('modified', false);
    }
    if(this.universalService.activeRepo == ActiveRepo.SHARE) {
      this.listService.listOptions.api.setColumnVisible('uploaded', false);
    //  return;
    }
    let colIdName = this.universalService.activeRepo == ActiveRepo.SHARE? 'created':'uploaded';
     if(this.listService.listViewSortOrder.includes("%2BcreatedDate")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: colIdName, sort: 'asc' }],
        defaultState: { sort: null },
      });
    }else if(this.listService.listViewSortOrder.includes("%2DcreatedDate")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: colIdName, sort: 'desc' }],
        defaultState: { sort: null },
      });
    }

    else if(this.listService.listViewSortOrder.includes("%2BobjectName")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'name', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }else if(this.listService.listViewSortOrder.includes("%2DobjectName")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'name', sort: 'desc' }],
        defaultState: { sort: null },
      });
    }

    else if(this.listService.listViewSortOrder.includes("%2BfileCreatedDate")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'created', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }else if(this.listService.listViewSortOrder.includes("%2DfileCreatedDate")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'created', sort: 'desc' }],
        defaultState: { sort: null },
      });
    }

    else if(this.listService.listViewSortOrder.includes("%2BsizeInBytes")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'size', sort: 'asc' }],
        defaultState: { sort: null },
      });
    }else if(this.listService.listViewSortOrder.includes("%2DsizeInBytes")){
      this.listService.listOptions.api.applyColumnState({
        state: [{ colId: 'size', sort: 'desc' }],
        defaultState: { sort: null },
      });
    }

  }

  hideOrShowSharedColumn(hide){
    hide = (  this.router.url.includes('/sharedwithme/')||this.router.url.includes('/sharedbyme/'))?true:false;
    var sharedColumn = this.listService.listOptions.api["columnModel"]["columnDefs"].find(col=>col["field"] == "shareDate");
    var lastModifiedColumn = this.listService.listOptions.api["columnModel"]["columnDefs"].find(col=>col["field"] == "modified");
    //if(hide){
      var indexOfSharedColum = this.listService.listOptions.api["columnModel"]["columnDefs"].indexOf(sharedColumn);
      var indexOflastModifiedColumn = this.listService.listOptions.api["columnModel"]["columnDefs"].indexOf(lastModifiedColumn);
      if(indexOfSharedColum >= 0){
        this.listService.listOptions.api["columnModel"]["columnDefs"][indexOfSharedColum].hide = hide;
      }
      if(indexOflastModifiedColumn >= 0){
        this.listService.listOptions.api["columnModel"]["columnDefs"][indexOflastModifiedColumn].hide = false;
      }
    //}
    /*else{
      var indexOfSharedColum = this.listService.listOptions.api["columnModel"]["columnDefs"].indexOf(sharedColumn);
      var indexOflastModifiedColumn = this.listService.listOptions.api["columnModel"]["columnDefs"].indexOf(lastModifiedColumn);
      if(indexOfSharedColum >= 0){
        this.listService.listOptions.api["columnModel"]["columnDefs"][indexOfSharedColum].hide = false;
      }
      if(indexOflastModifiedColumn >= 0){
        this.listService.listOptions.api["columnModel"]["columnDefs"][indexOflastModifiedColumn].hide = true;
      }
    }*/
    this.listService.listOptions.api.setGridOption('columnDefs', this.listService.listOptions.api["columnModel"]["columnDefs"])
  }

  //For List view
  selectObjectOnRightClick(event) {

    if(this.universalService.isUserOnSharedLinkByMe || (this.universalService.selectedTab == "teamfolders" && !this.router.url.includes('/teamfolders/'))) {
      return false;
    }
    this.universalService.isObjectRightClick = true;
    this.contextMenuService.showCustomContextMenu(event["event"]);
    //Check if current node/row is not selected, de-select other and select current.
    if (!event.node.isSelected()) {
      this.listService.deSelectAll(event);
      event.node.setSelected(true);
      
      this.universalService.selectedFile = event.data["FullObject"]

      if(this.universalService.showFileInfo){
        this.universalService.showFileInfo = false;
        AppEvents.optionSelected.next({fileInfo: false});
      }
    }
  }


  async onSelectionChanged(){
    this.universalService.showAutoSuggestion = false;
    if(this.universalService.dragDropWithinApp){
      return
    }
    var result;
    if(this.universalService.isRecentPanelSelected && !this.universalService.fetchAllRecentFiles) {
      return;
    }
    if(!this.listService.cellclick && this.universalService.isObjectRightClick == false){
      if(!this.universalService.showFileInfo){
        this.universalService.selectedFile = undefined;
      }
      this.contextMenuService.hideCustomContextMenu();
    }
    if (this.universalService.isObjectRightClick == true) {
      this.universalService.isObjectRightClick = true;
    } else {
      this.universalService.isObjectRightClick = false;
      this.contextMenuService.hideCustomContextMenu();
    }
    if ((this.universalService.popUpToBeOpened == "addToJioCloud")) {
      this.universalService.showMobOptionMenu = false;
      var file = this.listService.addToJCOptions.api.getSelectedRows();
      if (file[0]) {
        this.universalService.selectedFolder = file[0]["FullObject"];
        this.universalService.objectSelected = true;
      } else {
        this.universalService.objectSelected = false;
      }
      return;
    } 
    else if (this.universalService.popUpToBeOpened == "movePopUp" ||this.universalService.popUpToBeOpened == 'copyPopUp') {
      this.universalService.showMobOptionMenu = false;
      var file = this.listService.moveCopyOptions.api.getSelectedRows();
     
      if (file[0]) { 
        this.universalService.selectedFolder = file[0]["FullObject"];
        this.universalService.selectedFile = file[0]["FullObject"];
        
        if(this.universalService.popUpToBeOpened == "movePopUp"){

          var found = this.universalService.selectedNodes.filter(obj=> {
            const parentObjectKey = obj["parentObjectKey"] ? obj["parentObjectKey"] : obj["FullObject"]["parentObjectKey"];
            return parentObjectKey == this.universalService.selectedFolder["objectKey"];
          })

          this.loggerService.log('found an object match with slected folder object key',found)
          this.universalService.objectSelected = found.length>0 ? false: true;

        } else if(this.universalService.popUpToBeOpened == 'copyPopUp'){
          this.universalService.objectSelected = true;
        }
      } else {
          if(this.universalService.popUpToBeOpened == "copyPopUp"){
            this.universalService.selectedFolder = undefined;
            AppEvents.emit(EventsList.DECIDE_TO_ENABLE_BUTTON);
            return
          }
          var found = this.universalService.selectedNodes.find(obj=> {
            const parentObjectKey = obj["parentObjectKey"] ? obj["parentObjectKey"] : obj["FullObject"]["parentObjectKey"];
            return parentObjectKey == this.universalService.movePopupOpenFolderKey[0];
          })
          this.universalService.objectSelected = found ? false: true;
      }
      return;
    } 
    else if (this.universalService.listView) {
      this.universalService.selectedNodes = this.listService.listOptions.api.getSelectedRows();
      this.universalService.isFolderPresent();
    } 
    if (this.universalService.selectedNodes.length == 0) {
      this.universalService.selectedNodes = []
      this.universalService.selectionMode = false;
      this.universalService.showTopMenu = false;
      this.universalService.hideTopMenuOptions();  
    }else if( this.universalService.selectedNodes.length >= 1 && this.listService.cellclick && !this.universalService.isObjectRightClick){
      this.universalService.showTopMenu = true;
      this.universalService.showTopMenuOptions();  
      this.universalService.selectionMode = false;
      if(this.universalService.selectedNodes.length == 1 && this.universalService.selectedFile == ""){ // this is added because, when opening nested folders selected file was going empty.
        this.universalService.selectedFile = this.universalService.selectedNodes[0]["FullObject"];
      }
      result = await this.decideCall();
    }else if(this.universalService.selectedNodes.length >= 1 && !this.listService.cellclick){ 
      if(this.universalService.selectedNodes.length == 1){
        this.universalService.selectedFile = this.universalService.selectedNodes[0]["FullObject"]
      }
      this.universalService.openMoreOptions = false;
      this.universalService.showTopMenu = true;
      this.universalService.showTopMenuOptions();  
    } else if(this.universalService.selectedNodes.length >= 1 && this.universalService.isObjectRightClick){ 
      this.universalService.showTopMenu = true;
      this.universalService.showTopMenuOptions();  
   
    }
    this.refreshDiv();
    this.checkIfHeaderCheckBoxIsSelected();
    this.contextMenuService.decideContextMenuItems();
    this.listService.applicationRef.tick();

    this.listService.listOptions.api.forEachNode((node)=>{
      if(node.selected == true){
        if(this.universalService.popUpToBeOpened == ''){
          this.universalService.slectedRowId = node.rowIndex;
          this.indexsArray.push(node.rowIndex);
          this.universalService.listIndexOnPreview = node.rowIndex;
        }
        if(this.universalService.currentTab == 'audio')
          this.universalService.audioListIndexOnPreview=node.rowIndex;
  
          this.universalService.isRecentPanelSelected = false;
          $(".highlight-recent-item").removeClass("highlight-recent-item");
      } else {
        var index = node.rowIndex;
        var find = this.indexsArray.find(i=>i==index)
        if(find>=0){ 
          var indexOfFind = this.indexsArray.indexOf(find)
          this.indexsArray.splice(indexOfFind,1)
        }
        if(this.universalService.popUpToBeOpened == "copyPopUp" || this.universalService.popUpToBeOpened == "movePopUp"){
          this.universalService.selectedFolder = undefined;
          this.universalService.selectedFile = undefined;
        }
      }
  
      if(node.selected == false && this.listService.headerCheckBoxChecked){
        this.listService.deselectedNodesArray.push(node)
      }
  
      if (this.universalService.showFileInfo && this.universalService.selectedFile["objectKey"] != node["data"]["objectId"]) {
        this.universalService.showFileInfo = false;
        AppEvents.optionSelected.next({fileInfo: false});
      }
    })
    
    return result;
  }

  async clickedOnCell(event){   
    var focusedCell = this.listService.listOptions.api.getFocusedCell();

    if(focusedCell != undefined && (focusedCell["column"]["colId"]=="icon" || focusedCell["column"]["colId"]=="icon_1") && event.event.target.className.indexOf('NeueMore_Options') > -1){
      this.universalService.selectedNodes = [];
      this.universalService.selectedFile = event.data;
      this.universalService.selectedNodes.push(this.universalService.selectedFile);
      this.contextMenuService.showCustomContextMenu(event["event"]);
    } else {
      
      // currenttab= audio, not mobile, preview open ,selectedNodes.length!=0
      this.universalService.isObjectRightClick = false;
      this.contextMenuService.hideCustomContextMenu();
      this.universalService.selectedFile = "";
      if(this.universalService.selectedNodes.length==0){
        this.listService.cellclick = true;
        this.universalService.selectedFile = event.data["FullObject"]
      }
    }

  }

  decideCall(){
    if(!this.router.url.includes('trash') && !this.universalService.isUserOnSharedLinkByMe){
       if (this.universalService.selectedFile["format"] == "Folder" && this.universalService.isObjectRightClick == false) {
        // this.listService.openFolderContent = false;
        this.universalService.openFolderContent = true;
        this.universalService.showTopMenu = false;
        this.universalService.hideTopMenuOptions();  
        this.listService.openFolderContent = true;
        // this.universalService.selectedNodes = [];
        this.indexsArray=[]
        return "open folder";
      }else {
        if (this.universalService.isObjectRightClick == false && this.universalService.selectedFile != undefined) {
          if(this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio' && this.universalService.selectedTab != "Album Details") {
            var focusedCell = this.listService.listOptions.api.getFocusedCell();
            if(focusedCell["column"]["colId"]=="ImagePath"){ 
              this.universalService.showPreview = true;
              this.universalService.showDirectMiniPlayer = false;
              this.indexsArray=[]
            }else if(focusedCell["column"]["colId"]=="checkIcon"){
              
            } 
            else {
              this.universalService.showPreview = false;
              this.universalService.showFullViewAudioPlayer = false;
              this.universalService.showLoader = false;
              this.universalService.audioPreview = false;
              if(this.universalService.showMiniPlayer == true || $("#mini_player_root").is(':visible') ) {
                this.previewImplementation.openNewAudioInMiniPlayer();
              }
              this.universalService.showMiniPlayer = true;
              this.universalService.showDirectMiniPlayer = true;
              this.listService.deSelectAll(null);
            }
          } else { 
            this.indexsArray=[]
            this.universalService.showPreview = true; 
            this.universalService.showDirectMiniPlayer = false;
          }

          this.db.clearStore("RecentFilesMetadata");  // refresh recent files in all files to latest previewed file
        }
      }
    }
      this.universalService.isObjectRightClick = false;
      this.contextMenuService.hideCustomContextMenu();
      return "";
  }

  
  

  checkIfHeaderCheckBoxIsSelected(){ 
    if(this.universalService.selectedNodes.length == this.listService.listOptions.api.getDisplayedRowCount() && this.universalService.selectedNodes.length != 0){
      this.listService.headerCheckBoxChecked = true;
      this.listService.deselectedNodesArray = [];
    }else{
      if(this.universalService.selectedNodes.length == 0){
        this.listService.headerCheckBoxChecked = false;
        this.listService.deselectedNodesArray = [];
      }
    }  
  }

  
  refreshDiv(){
    if(this.universalService.selectedNodes.length>0){
      // jQuery(".left-icon-set").show()
      // jQuery("#topMenuCounter").html(this.universalService.selectedNodes.length + " Selected");
      setTimeout(()=>{
        if(this.universalService.listView ){
          let ele = (document.querySelector('.heading-wrap')) as any
          if(ele){
            // ele.click()
          }
        }
        // // setTimeout(()=>{
        //   var iframe = document.getElementById("trashFrame");
        //   iframe.setAttribute("style", "visibility:hidden;display:none")
        //   iframe.setAttribute("target", "_blank");
        //   iframe.click();
        // // },5000)
      },500)
    }else if(this.universalService.showPreview && this.universalService.selectedFile){
      // jQuery(".left-icon-set").show()
      this.universalService.selectedNodes.push(this.universalService.selectedFile);
    }else{
      // jQuery(".left-icon-set").hide()
      this.universalService.showTopMenu = false;
      this.universalService.hideTopMenuOptions();  
    }
  }    



  updateSummaryCountsAndUI(list,indexsArray,executedTask){
    indexsArray = Array.from(new Set(indexsArray));
    var newData = [];
    var audioNewData = [];
    var currentIndex;
    if(indexsArray.length == 0 && this.universalService.showPreview){
        let indexValue=-1
        if( !this.universalService.isMobileDevice && this.universalService.currentTab == 'audio')
          indexValue= this.universalService.audioListIndexOnPreview
        else
          indexValue= this.universalService.listIndexOnPreview
        var rowNode = this.listService.listOptions.api.getDisplayedRowAtIndex(indexValue);
        currentIndex = indexValue
        newData.push(rowNode.data)
    }else{
      indexsArray.map(idx=>{
        var rowNode = this.listService.listOptions.api.getDisplayedRowAtIndex(idx);
        currentIndex=idx;
        newData.push(rowNode.data)
      })
    }
    let audioPreviewDelete=false;
    let audioMoveToPPF = false;
    if(this.universalService.showPreview && executedTask =='TRASH' && this.universalService.activeRepo == 'main' 
      && this.universalService.currentTab == 'audio' ){
        audioPreviewDelete=true;
    }else if(this.universalService.showPreview && executedTask == "MOVETOPF" && this.universalService.activeRepo == 'main' 
    && this.universalService.currentTab == 'audio' ){
      audioMoveToPPF = true;
    }
    if( this.universalService.showPreview &&
          (executedTask =='TRASH' || executedTask == "FTR" || executedTask == "MOVETOPF" || (this.universalService.currentTab =='allfiles' && executedTask =='MOVE'))){
            if((currentIndex+1-this.universalService.atPreviewfolderCount)>(this.universalService.objectsPreviewArray.length-1)){
              this.universalService.listIndexOnPreview = 0;
              if(( ((this.universalService.currentTab =='docs' || this.universalService.currentTab =='audio') && executedTask == "MOVETOPF") || this.universalService.currentTab =='allfiles' || this.universalService.currentTab =='sharedFiles') && this.universalService.atPreviewfolderCount>0){
                this.universalService.listIndexOnPreview=this.universalService.atPreviewfolderCount;
              }
            }
            else{
              this.universalService.listIndexOnPreview = currentIndex ;  

            }
            
            if(audioPreviewDelete || audioMoveToPPF){
              this.listService.rowData.splice(currentIndex,1);
              this.listService.audioPreviewOptions.api.setRowData(this.listService.rowData);
              // this.listService.listOptions.getRowClass = function(params) {
              //   // if(params.data["FullObject"]["objectType"]=="FR")
              //   return 'objectId'+params.data.objectId;
              // }
              this.listService.listOptions.api.setRowData(this.listService.rowData);
            }
    }else if( executedTask =='TRASH'  && this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio' && this.universalService.showMiniPlayer){
        var audiosList = this.listService.rowData
        this.listService.rowData = audiosList.filter(value => ! newData.includes(value));
        //Handle playing song in delete scenario
        if(executedTask =='TRASH' && this.universalService.showMiniPlayer) {
          var deletedRowData = audiosList.filter(value => newData.includes(value));
          var find = deletedRowData.find(obj=>obj["objectId"] == this.universalService.selectedAudioFile.objectKey);
          if(find){ // If deleted file is same as one playing.. stop player
            this.universalService.stopAndCloseAudioPlayer();
          }          
          /*if(find) {
            var clapprImpRef  =  ClapprImplementation.getInstance(this.universalService);
            var indexofAudio = audiosList.indexOf(find);
            var miniPlayStatus = this.universalService.showMiniPlayer;
            if(this.listService.rowData.length > 1) {//if more than 1 row, play next
              this.universalService.stopAndCloseAudioPlayer();
              this.universalService.selectedAudioFile = this.listService.rowData[indexofAudio]["FullObject"];
              this.universalService.selectedFile = this.universalService.selectedAudioFile;
              clapprImpRef.audioplayer = this.universalService.player;
              this.universalService.showMiniPlayer = miniPlayStatus;
              clapprImpRef.openClappr();
              
              // if(indexofAudio == 0) {//play next
              //   this.universalService.selectedAudioFile = this.listService.rowData[indexofAudio]["FullObject"];
              // } else if (indexofAudio == this.listService.rowData.length - 1) {//play prev
              //   this.universalService.selectedAudioFile = this.listService.rowData[indexofAudio]["FullObject"];
              // }
            } else if(this.listService.rowData.length == 1) {//if only one row was there, stop player
              this.universalService.stopAndCloseAudioPlayer();
            }
          }*/
        }
    }

    if(!audioPreviewDelete){
      if (indexsArray.length == 0 && list.length == 1){ // if a single is dragged without selection to move
        newData = [];
        newData.push(list[0]);
      }
      var res = this.listService.listOptions.api.applyTransaction({ remove: newData })
      var rowCount = this.listService.listOptions.api.getDisplayedRowCount();
       if(rowCount == 0){ 
        if(this.universalService.openFolderContent){
          if(this.universalService.currentTab == 'sharedFiles'){
            this.universalService.emptyShared = true;
          }else{
            this.universalService.emptyFolder = true;
          }
        }else{
          // this.universalService.emptyTab = true;
        }
      }

      this.listService.listOptions.api.redrawRows() // this is used to update the grid with new rowdata
      this.loggerService.log("res from delete",res)
    }
    this.indexsArray = []
    this.listService.deSelectAll(null);
    if(this.universalService.showPreview && (executedTask=='TRASH' || ( (this.universalService.currentTab == "docs"||this.universalService.currentTab == "audio") && executedTask=='MOVETOPF' ) || (this.universalService.currentTab == "PrivateFolder" && executedTask=='MOVE' ) || this.universalService.currentTab=='allfiles') && this.universalService.selectedTab != "Album Details"){
      this.previewImplementation.deleteORMoveObject(executedTask);
    }else if(this.universalService.showPreview && executedTask=='UNSETFAV' && this.universalService.currentTab=='Favorites' &&  this.universalService.selectedTab != "Album Details"){
      this.previewImplementation.deleteORMoveObject(executedTask);
    }
    if(this.universalService.currentTab == 'sharedFiles'){
      if(executedTask == 'TRASH' && !this.universalService.showPreview) {
        this.universalService.objectsPreviewArray.splice(currentIndex, 1);
      }
      var newSharedData = [];
      this.listService.listOptions.api.forEachNode(node => newSharedData.push(node.data));
      if(newSharedData.length == 0 ) {
        this.universalService.emptyShared = true;
      } else {
        this.universalService.emptyShared = false;
      }
    }
  }

  async updateOnlyTheUI(list,executedTask){
    let self = this
    var newData = [];
    let md=undefined;

    if((self.universalService.selectedTab == "Album Details" || self.router.url.includes('/favorites/myalbums'))&& executedTask == "FRN"){
      md = new Date(new Date().getTime());
    }
    
    if(self.universalService.updatedObject!=undefined && self.universalService.updatedObject!=null){
        md = new Date(self.universalService.updatedObject.objects[0].object.lastModifiedDate);
    }else if (self.universalService.updatedObject == null && self.universalService.currentTab == 'sharedFiles'){
              var lastModifiedDate = new Date().getTime();
              md = new Date(lastModifiedDate);
    }
    if(self.indexsArray.length == 0 || self.universalService.showPreview){
      let indexValue=-1
      if( !self.universalService.isMobileDevice && self.universalService.currentTab == 'audio')
        indexValue= self.universalService.audioListIndexOnPreview
      else
        indexValue= self.universalService.listIndexOnPreview
      
      if(indexValue != undefined) {
        var rowNode = self.listService.listOptions.api.getDisplayedRowAtIndex(indexValue);
        if(executedTask == "SETFAV"){
          rowNode.setData(rowNode.data)
          newData.push(rowNode.data)
        }else if(executedTask == "UNSETFAV"){
          if(self.universalService.currentTab == 'Favorites'){
            // await  self.updateSummaryCountsAndUI(list,[indexValue],executedTask)
          }else{
            rowNode.setData(rowNode.data)
          }
          newData.push(rowNode.data)
        }
        else if(executedTask == "RENAME" || executedTask == "FRN"){
          var fileName = self.universalService.selectedFile["objectName"].split('.').slice(0, -1).join('.');
          rowNode.data.name = fileName;
          var extns = self.universalService.selectedFile["objectName"].split(".");
          if(self.router.url.includes('/teamfolders/') || this.universalService.searchType == 'teamfolder'){
            rowNode.setData(rowNode.data)
          } else {
            if (self.universalService.selectedFile["objectName"].length > 20) {
              rowNode.data["FullObject"]["objectShortName"] = self.universalService.selectedFile["objectName"].slice(0, 14) + "..." + extns[extns.length - 1];
              rowNode.data["FullObject"]["modifiedOn"] = self.weekDays[md.getDay()] + ", " + md.getDate() + " " + self.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
              rowNode.setData(rowNode.data)
            } else {
              rowNode.data["FullObject"]["objectShortName"] = self.universalService.selectedFile["objectName"]
              rowNode.data["FullObject"]["modifiedOn"] = self.weekDays[md.getDay()] + ", " + md.getDate() + " " + self.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
              rowNode.setData(rowNode.data)
            }
          }
          self.universalService.updatedObject = undefined
          var data = rowNode.data
          newData.push(data)
        }
      }
      
    }else{
      if((self.universalService.selectedTab == "Album Details" || self.router.url.includes('/favorites/myalbums'))&& executedTask == "FRN"){
        md = new Date(new Date().getTime());
      }
      self.indexsArray.map(idx=>{
        self.universalService.listIndexOnPreview=idx;
        var rowNode = self.listService.listOptions.api.getDisplayedRowAtIndex(idx);
        var object = list.find(obj=>obj["objectId"] == rowNode.data.objectId);
        if(executedTask == "SETFAV" || executedTask == "SHAREPERMISSION"){
          rowNode.setData(object)
        }else if(executedTask == "UNSETFAV"){
          if(self.universalService.currentTab == 'Favorites'){
           // self.updateSummaryCountsAndUI(list,[idx],executedTask)
          }else{
          rowNode.setData(object)
          }
        }
        else if(executedTask == "RENAME" || executedTask == "FRN"){

          var fileName = self.universalService.selectedFile["objectName"].split('.').slice(0, -1).join('.');
          rowNode.data.name = fileName;
          // rowNode.setDataValue("name",fileName)
          var extns = self.universalService.selectedFile["objectName"].split(".");
          if(self.router.url.includes('/teamfolders/') || this.universalService.searchType == 'teamfolder'){
            rowNode.setData(object);
          } else {
            if (self.universalService.selectedFile["objectName"].length > 20) {
              object["FullObject"]["objectShortName"] = self.universalService.selectedFile["objectName"].slice(0, 14) + "..." + extns[extns.length - 1];
              rowNode.data["FullObject"]["modifiedOn"] = self.weekDays[md.getDay()] + ", " + md.getDate() + " " + self.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
              rowNode.setData(object)
            } else {
              object["FullObject"]["objectShortName"] = self.universalService.selectedFile["objectName"]
              rowNode.data["FullObject"]["modifiedOn"] = self.weekDays[md.getDay()] + ", " + md.getDate() + " " + self.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
              rowNode.setData(object);
            }
          }
          var data = rowNode.data
          newData.push(data)
        }
      })
    }
    if(executedTask == "UNSETFAV" && self.universalService.currentTab == 'Favorites'){
      await self.updateSummaryCountsAndUI(list,self.indexsArray,executedTask)
      if(self.listService.listOptions.api.getDisplayedRowCount() == 0)
      self.universalService.emptyFav = true 
    }
    if(self.universalService.showPreview  && executedTask=='RENAME'){
      var extns = self.universalService.selectedFile.objectName.split(".");
      if (self.universalService.isMobileDevice && self.universalService.selectedFile.objectName.length > 14){
        self.universalService.selectedFile.objectShortName = self.universalService.selectedFile.objectName.slice(0, 8) + "..." + extns[extns.length - 1];
      }else if (!self.universalService.isMobileDevice && self.universalService.selectedFile.objectName.length > 20){
        self.universalService.selectedFile.objectShortName = self.universalService.selectedFile.objectName.slice(0, 14) + "..." + extns[extns.length - 1];
      }else{
        self.universalService.selectedFile.objectShortName = self.universalService.selectedFile.objectName
      }
    }
    if(executedTask == "RENAME" && self.universalService.fetchAllRecentFiles){
      var tempData = [];
      self.listService.listOptions.api.forEachNode(node => tempData.push(node.data));
      var find = tempData.find(obj=>obj["FullObject"]["objectKey"] == newData[0]["FullObject"]["objectKey"]);
      if(find){
        let indexInSortArray = tempData.indexOf(find);
        tempData.splice(indexInSortArray,1);
        tempData = newData.concat(tempData);
        // self.listService.listOptions.getRowClass = function(params) {
        //   // if(params.data["FullObject"]["objectType"]=="FR")
        //   return 'objectId'+params.data.objectId;
        // }
        self.listService.listOptions.api.setRowData(tempData);
      }
    }
    else{
      var res = self.listService.listOptions.api.applyTransaction({ update: newData })
    }
    self.listService.listOptions.api.refreshCells() // this is used to update the grid with new rowdata
    self.loggerService.log("res",res)
    self.indexsArray = []
    self.listService.deSelectAll(null);

    if(self.universalService.currentTab == 'audio' && self.universalService.showPreview){
        var rowNode = self.listService.audioPreviewOptions.api.getDisplayedRowAtIndex(self.universalService.audioListIndexOnPreview);
        var fileName = self.universalService.selectedFile["objectName"].split('.').slice(0, -1).join('.');
        rowNode.data.name = fileName;
        var extns = self.universalService.selectedFile["objectName"].split(".");
          if (self.universalService.selectedFile["objectName"].length > 20) {
            rowNode.data["FullObject"]["objectShortName"] = self.universalService.selectedFile["objectName"].slice(0, 14) + "..." + extns[extns.length - 1];
            rowNode.setData(rowNode.data)
          } else {
            rowNode.data["FullObject"]["objectShortName"] = self.universalService.selectedFile["objectName"]
            rowNode.setData(rowNode.data)
          }
          var data = rowNode.data
          newData.push(data)
          var res = self.listService.audioPreviewOptions.api.applyTransaction({ update: newData })
          self.listService.audioPreviewOptions.api.redrawRows() // this is used to update the grid with new rowdata
        
    }


  }

  updateListViewData(objectList){
    var self = this;
    objectList = this.restrictDuplicateObj(objectList);
    if(objectList.length == 0){
      return
    }
    let response = this.customMetadata.segregateData(objectList, 'allfiles');
    let newRow = [];
    response.map(object => {
      var fileExtension = "." + object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
      var fileName = object.objectName.split('.').slice(0, -1).join('.');

      if(this.universalService.currentTab == 'teamfolders') {
        newRow.push({
          "name": fileName,
          "extension": fileExtension,
          "size": object["objectSize"],
          "createdByName": object["objectCreatedBy"] ? (object["objectCreatedBy"]["firstName"] ? object["objectCreatedBy"]["firstName"] : "-") + " " + (object["objectCreatedBy"]["lastName"] ? object["objectCreatedBy"]["lastName"] : "-") : (USER_DETAILS["USER_DETAILS"]["firstName"] + " " + USER_DETAILS["USER_DETAILS"]["lastName"]),//On copy show logged in user as creator of object if not available
          "type": object["displayName"].substring(0,1).toUpperCase()+object["displayName"].substring(1),
          "created": object["gridDate"],
          "FullObject": object,
          "objectId": object["objectKey"],
          "ImagePath":object["imageTranscodeUrl"],
          "tfKey": object["tfKey"],
          "iconClassName" : 'three-dot'
        })
      } else {

        newRow.push({
          "name": fileName,
          "extension": fileExtension,
          "type": object["displayName"].substring(0, 1).toUpperCase() + object["displayName"].substring(1),
          "size": object["objectSize"],
          "created": object["gridDate"],
          "modified": object["modifiedDate"],
          "ImagePath": object["imageTranscodeUrl"],
          "FullObject": object,
          "objectId": object["objectKey"],
          "drag":self.universalService.allowMoveDrag,
          "uploaded": object["displayName"] == "Folder"?object["gridDate"]:object["uploadedDateCol"],
        })
      }
    
    })
    this.rowData = this.getAllListViewData();
    if(this.rowData.length == 0){
      this.rowData.push(newRow[0]);
      let arr = this.customSort.sortListViewFilesByAttribute(this.rowData, "Descending", "fileCreatedDate");
      if(this.universalService.currentTab == 'teamfolders') {
        this.decideListOptions('teamfoldercontent');
      } else {
        this.decideListOptions('allfiles');
      }

      // this.listService.listOptions.getRowClass = function(params) {
      //   // if(params.data["FullObject"]["objectType"]=="FR")
      //   return 'objectId'+params.data.objectId;
      // }
      this.listService.listOptions.api.setRowData(arr);
      this.listService.listOptions.api.sizeColumnsToFit();
      this.listService.setHeaderHeight(60);
      return;
    }else{
      this.rowData.push(newRow[0]);
    }
    let sortParam = this.listService.listOptions.api.getColumnState().find(col=>col.sort);
    sortParam = sortParam;
    const direction = sortParam["sort"] == "asc" ? "Ascending" : "Descending";
    let type = "";
    if(sortParam["colId"].includes("name")) {
      type = "objectName";
    } else if(sortParam["colId"].includes("size")){
      type = "sizeInBytes";
    } else if(sortParam["colId"].includes("created")){
      type = "fileCreatedDate";
    } else if(sortParam["colId"].includes("type")){
      type = "mimeType";
    } else if(sortParam["colId"].includes("uploaded")){
      type = "createdDate";
    } 
    let arr = this.customSort.sortListViewFilesByAttribute(this.rowData, direction, type);
    // this.listService.listOptions.getRowClass = function(params) {
    //   // if(params.data["FullObject"]["objectType"]=="FR")
    //   return 'objectId'+params.data.objectId;
    // }
    this.listService.listOptions.api.setRowData(arr);
  }
  
  //To update list view in shared uploaded files/list data
  updateSharedListViewData(objectList, currentTab){
    let self = this;
    objectList = self.restrictDuplicateObj(objectList);
    if(objectList.length == 0){
      return
    }
    let response = this.customMetadata.segregateData(objectList, "allfiles");
    this.rowData = [];
    let newRow = [];
    response.map(object => {
      var fileExtension = "." + object.objectName.substring(object.objectName.lastIndexOf('.') + 1);
      var fileName = object.objectName.split('.').slice(0, -1).join('.');
      newRow.push({
        "name": fileName,
        "extension" : fileExtension,
        "owner": ((currentTab == 'sent') ? (USER_DETAILS["USER_DETAILS"]["firstName"] + " " + USER_DETAILS["USER_DETAILS"]["lastName"]) : undefined),
        "sharedBy":((currentTab == 'received') ? (USER_DETAILS["USER_DETAILS"]["firstName"] + " " + USER_DETAILS["USER_DETAILS"]["lastName"]) : undefined),
        "size": object["objectSize"],
        "type": object["format"].substring(0,1).toUpperCase()+object["format"].substring(1),
        "modified": self.universalService.openFolderContent?object["modifiedDate"]:object["shareModified"],
        "shareDate":object["sharedDate"],
        // "comment": object["comment"],
        "ImagePath": object["imageTranscodeUrl"],
        "FullObject": object,
        "objectId": object["objectKey"]
      })
    })
    //this.rowData.push(newRow[0]);
    this.rowData = this.getAllListViewData();
    if(this.rowData.length == 0){
      this.rowData.push(objectList[0]);
      if(currentTab == 'sent'){
        this.decideListOptions('sharedbyme');
      }else{
        this.decideListOptions('sharedwithme');
      }
      this.listService.listOptions.api.setRowData(newRow);
      this.listService.listOptions.api.sizeColumnsToFit();
      this.listService.setHeaderHeight(60);
      return;
    }
    this.listService.listOptions.api.applyTransaction({ add: newRow});
    let sortParam = this.listService.listOptions.api.getColumnState().find(col=>col.sort);
    sortParam = sortParam;
    const direction = sortParam["sort"] == "asc" ? "Ascending" : "Descending";
    let type = "";
    if(sortParam["colId"].includes("name")) {
      type = "objectName";
    } else if(sortParam["colId"].includes("size")){
      type = "sizeInBytes";
    } else if(sortParam["colId"].includes("modified")){
      type = "lastModifiedDate";
    }
    var newSharedData = [];
    this.listService.listOptions.api.forEachNode(node => newSharedData.push(node.data));
    if(this.universalService.emptyShared) {
      var sort = "default";
      this.decideListOptions(currentTab+sort)
      this.universalService.emptyShared = false;
    }
    let arr = this.customSort.sortListViewFilesByAttribute(newSharedData, direction, type);
    // this.listService.listOptions.getRowClass = function(params) {
    //   // if(params.data["FullObject"]["objectType"]=="FR")
    //   return 'objectId'+params.data.objectId;
    // }
    this.listService.listOptions.api.setRowData(arr);
  }

  uploadDone(){
      let classRef = this;
      AppEvents.removeAllEventListener(EventsList.UPLOAD_COMPLETED);
      AppEvents.on(EventsList.UPLOAD_COMPLETED, function(){
        setTimeout(()=>{
          classRef.selectRow();
        },3500) 
      })
  }
  selectRow(){
    var found='';
    this.newlyAddedRowData = [];
    this.universalService.selectedRowAfterUpload =[]
    if(this.universalService.listView && !this.universalService.isMobileDevice){
      this.listService.listOptions.api.forEachNode(node => this.newlyAddedRowData.push(node.data));
      this.universalService.MarkNewObjArray.map(item=>{
        found = this.newlyAddedRowData.find(row =>row.objectId == item.objectKey)
        if (found) {
          let index = this.newlyAddedRowData.indexOf(found);
          this.universalService.selectedRowAfterUpload.push(index)
        }
      })
    }
   
    // this.selectedRowAfterUpload.map(index=>{
    //   let rowNode = this.listService.listOptions.api.getDisplayedRowAtIndex(index);
    //   rowNode.setSelected(true);
    // })
  }

  restrictDuplicateObj(objectArray){
    var newlyAddedRowData = [];
      this.listService.listOptions.api.forEachNode(node => newlyAddedRowData.push(node.data));
      newlyAddedRowData.map(obj=>{
        objectArray.map((object,index)=>{
          var objectKey = object["FullObject"]? object["FullObject"].objectKey : object.objectKey
          if(obj["FullObject"]["objectKey"] == objectKey){
            objectArray.splice(index,1)
          }
        })
      })
      return objectArray;
  }
  
  clearIndexArray(){
      this.indexsArray=[];
  } 

  getAllListViewData(){
    let dataArr = [];
    this.listService.listOptions.api.forEachNode(node => dataArr.push(node.data));
    return dataArr;
  }


  sortListViewData(){
    this.rowData = this.getAllListViewData();
    let sortParam = this.listService.listOptions.api.getColumnState().find(col=>col.sort);
    sortParam = sortParam;
    const direction = sortParam["sort"] == "asc" ? "Ascending" : "Descending";
    let type = "";
    if(sortParam["colId"].includes("name")) {
      type = "objectName";
    } else if(sortParam["colId"].includes("size")){
      type = "sizeInBytes";
    } else if(sortParam["colId"].includes("created")){
      type = "fileCreatedDate";
    } else if(sortParam["colId"].includes("type")){
      type = "mimeType";
    } else if(sortParam["colId"].includes("uploaded")){
      type = "createdDate";
    } 
    let arr = this.customSort.sortListViewFilesByAttribute(this.rowData, direction, type);
    // this.listService.listOptions.getRowClass = function(params) {
    //   // if(params.data["FullObject"]["objectType"]=="FR")
    //   return 'objectId'+params.data.objectId;
    // }
    this.listService.listOptions.api.setRowData(arr);
  }


  initializeAgGridForIfUploadedInEmptyView(tab){
    switch(tab){
      case 'allfiles':
        if(!this.listService.listOptions.api["columnModel"])
          this.listService.listOptions.api.setGridOption('columnDefs', this.listService.allFilesDefs)
          break;
      case "sharedbyme" :
        if(!this.listService.listOptions.api["columnModel"])
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.SharedByMeDefs);
        break;
      case "sharedwithme" :
        if(!this.listService.listOptions.api["columnModel"])
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.SharedWithMeDefs);
        break;
      case 'teamfoldercontent':
        this.listService.listOptions.api.setGridOption('columnDefs', this.listService.teamFolderContentDefs);
        break;
      default:
          console.log("tab value not found",tab);
    }
  }

}